import $ from 'jquery';
import Util from "./utils";


$(function () {
    let passwordEmailVerification = $("#email-verification-link-expired-form");
    if (passwordEmailVerification && passwordEmailVerification.length > 0) {
        initEmailVerificationExpiredForm();
    }

    let expiredEmailUpdateVerification = $("#email-update-verification-link-expired-form");
    if (expiredEmailUpdateVerification && expiredEmailUpdateVerification.length > 0) {
        initEmailUpdateVerificationExpiredForm();
    }

    let confirmEmailAddressPrompt = $(".email-verification-confirm-email");
    if (confirmEmailAddressPrompt && confirmEmailAddressPrompt.length > 0) {
        initEmailVerificationConfirmEmailAddress();
    }
});

/**
 * Sets up JS needed for Email Verificaiton Confirm Address page to work
 */
function initEmailVerificationConfirmEmailAddress() {
    let confirmEmailAddressPrompt = $(".email-verification-confirm-email");
    let resendVerificationEmail = confirmEmailAddressPrompt.find(".resend-email");
    resendVerificationEmail.on("click", function () {
        // Reset error messaging
        resendVerificationEmail.find(".form-status").hide();
        resendVerificationEmail.find(".form-status").removeClass("form-status_error form-status_success");
        resendVerificationEmail.find(".form-status p").html("");

        // Get original reset token from query
        var queryParams = Util.getUrlParameters();
        var verificationToken = queryParams["verificationToken"];
        // Get Anti-CSRF token
        var csrfToken = $("[name='__RequestVerificationToken']").val();

        //Retreieve the communities of the given market area
        $.ajax("/acct/emailverification/resendemailverification/",
            {
                type: 'POST',
                data: {
                    // VerificationToken needs to be sent thru AJAX from query param
                    VerificationToken: verificationToken
                },
                beforeSend: function (request) {
                    // Add CSRF token to the header
                    request.setRequestHeader("__RequestVerificationToken", csrfToken);
                },
                success: function (response) {
                    let status = response.Status;

                    if (status === "error") {
                        confirmEmailAddressPrompt.find(".form-status").addClass("form-status_error");
                        confirmEmailAddressPrompt.find(".form-status p").html(response.ErrorMessage);
                    }
                    else {
                        confirmEmailAddressPrompt.find(".form-status").addClass("form-status_success");
                        confirmEmailAddressPrompt.find(".form-status p").html("Successfully resent email verification link.");
                    }

                    confirmEmailAddressPrompt.find(".form-status").show();
                },
                error: function (error) {
                    confirmEmailAddressPrompt.find(".form-status").addClass("form-status_error");
                    confirmEmailAddressPrompt.find(".form-status p").html("Unexpected error occured. Please try again.");
                    confirmEmailAddressPrompt.find(".form-status").show();
                }
            })
    });
}

/**
 * Sets up JS needed for Email Verificaiton Failed page to work
 */
function initEmailVerificationExpiredForm() {
    let emailVerificationForm = $("#email-verification-link-expired-form");
    let emailTimeout = emailVerificationForm.find("#email-verification-link-expired-form_timeout").val();
    emailVerificationForm.on("submit", function (e) {
        e.preventDefault();

        // Reset error messaging
        emailVerificationForm.find(".form-status").hide();
        emailVerificationForm.find(".form-status").removeClass("form-status_error form-status_success");
        emailVerificationForm.find(".form-status p").html("");

        // Get original reset token from query
        var queryParams = Util.getUrlParameters();
        var verificationToken = queryParams["verificationToken"];
        // Get Anti-CSRF token
        var csrfToken = $("[name='__RequestVerificationToken']").val();

        //Retreieve the communities of the given market area
        $.ajax("/acct/emailverification/expiredformsubmit/",
            {
                type: 'POST',
                data: {
                    VerificationToken: verificationToken
                },
                beforeSend: function (request) {
                    // Add CSRF token to the header
                    request.setRequestHeader("__RequestVerificationToken", csrfToken);
                },
                success: function (response) {
                    let status = response.Status;

                    if (status === "error") {
                        emailVerificationForm.find(".form-status").addClass("form-status_error");
                        emailVerificationForm.find(".form-status p").html(response.ErrorMessage);
                    }
                    else {
                        emailVerificationForm.find(".form-status").addClass("form-status_success");
                        var timeoutstring = emailTimeout + (emailTimeout != 1 ? " hours" : " hour");
                        emailVerificationForm.find(".form-status p").html("We have resent a link to your email that expires in " + timeoutstring + ". Please click on the link in the email to confirm your email address and activate your account.");
                    }
                    emailVerificationForm.find(".form-status").show();
                },
                error: function (error) {
                    emailVerificationForm.find(".form-status").addClass("form-status_error");
                    emailVerificationForm.find(".form-status p").html("Unexpected error occured. Please try again.");
                    emailVerificationForm.find(".form-status").show();
                }
            });
    });
}

/**
 * Sets up JS needed for Email Update Verificaiton Failed page to work
 */
function initEmailUpdateVerificationExpiredForm() {
    let emailVerificationForm = $("#email-update-verification-link-expired-form");
    let emailTimeout = emailVerificationForm.find("#email-update-verification-link-expired-form_timeout").val();
    emailVerificationForm.on("submit", function (e) {
        e.preventDefault();

        // Reset error messaging
        emailVerificationForm.find(".form-status").hide();
        emailVerificationForm.find(".form-status").removeClass("form-status_error form-status_success");
        emailVerificationForm.find(".form-status p").html("");

        // Get Anti-CSRF token
        var csrfToken = $("[name='__RequestVerificationToken']").val();
        var adID = $("#email-verification-adid").val();
        var email = $("#email-verification-email").val();
        var isSendAllEmail = $("#email-verification-issendallemail").val();

        //Retreieve the communities of the given market area
        $.ajax("/acct/emailverification/expiredemailupdateformsubmit",
            {
                type: 'POST',
                data: {
                    ADID: adID,
                    Email: email,
                    IsSendAllEmail: isSendAllEmail
                },
                beforeSend: function (request) {
                    // Add CSRF token to the header
                    request.setRequestHeader("__RequestVerificationToken", csrfToken);
                },
                success: function (response) {
                    let status = response.Status;

                    if (status === "error") {
                        emailVerificationForm.find(".form-status").addClass("form-status_error");
                        emailVerificationForm.find(".form-status p").html(response.ErrorMessage);
                    }
                    else {
                        emailVerificationForm.find(".form-status").addClass("form-status_success");
                        var timeoutstring = emailTimeout + (emailTimeout != 1 ? " hours" : " hour");
                        emailVerificationForm.find(".form-status p").html("We have resent a link to your email that expires in " + timeoutstring + ". Please click on the link in the email to confirm your email address and update your account.");
                    }
                    emailVerificationForm.find(".form-status").show();
                },
                error: function (error) {
                    emailVerificationForm.find(".form-status").addClass("form-status_error");
                    emailVerificationForm.find(".form-status p").html("Unexpected error occured. Please try again.");
                    emailVerificationForm.find(".form-status").show();
                }
            });
    });
}